import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Role } from 'core/enum/role';
import Cookies from 'js-cookie';

export default function useAuth() {
  const user = useSelector((state: RootState) => state.user.user);
  const isAuthenticated = Boolean(Cookies.get('accesstoken'));

  const isCandidate = user?.role === Role.CANDIDATE;
  const isEmployee = user?.role === Role.EMPLOYEE;
  const isRecruiter = user?.role === Role.RECRUITER;
  const isAdmin = user?.role === Role.ADMIN;
  const isCompanyUser = isRecruiter || isAdmin;

  return {
    isAuthenticated,
    user,
    isCandidate,
    isEmployee,
    isRecruiter,
    isAdmin,
    isCompanyUser
  };
}
